module.exports = __webpack_public_path__ + "static/media/vacuderma-5.8d4e693f.jpg";